import React, { Fragment, useEffect, useState } from 'react'
import { Container, Row, Col } from 'reactstrap'
import Drawer from '@material-ui/core/Drawer'
import { useSelector } from 'react-redux'
import { CAPACITY, FEASIBILITY, FILE_URL, TIMELINE } from '../../../../config/constants'

function Attachament(props) {
  const { index, gridListing, initialViewMode = 'attachments' } = props
  const viewCostingData = useSelector((state) => state.costing.viewCostingDetailData)
  const Data = gridListing ? index : viewCostingData[index]
  const [files, setFiles] = useState([]);
  const [filesFeasibility, setFilesFeasibility] = useState([]);
  const [isRfqAttachments, setIsRfqAttachments] = useState(false)
  const [filesCapacity, setFilesCapacity] = useState([]);
  const [filesTimeline, setFilesTimeline] = useState([]);
  const [viewMode, setViewMode] = useState(initialViewMode); // 'attachments' or 'remarks'

  useEffect(() => {
    let list = (Data.attachment || Data.Attachements)
    let attachmentList = filterAttachments(list, null)
    setIsRfqAttachments(list?.length !== attachmentList?.length)
    setFiles(attachmentList)
    let attachmentFeasibility = filterAttachments(list, FEASIBILITY)
    setFilesFeasibility(attachmentFeasibility)
    let attachmentCapacity = filterAttachments(list, CAPACITY)
    setFilesCapacity(attachmentCapacity)
    let attachmentTimeline = filterAttachments(list, TIMELINE)
    setFilesTimeline(attachmentTimeline)

  }, [Data])

  const filterAttachments = (list, value) => {
    let filteredList = list?.filter(element => element.AttachementCategory === value)
    return filteredList
  }

  /*
   * @method toggleDrawer
   * @description closing drawer
   */
  const toggleDrawer = (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return
    }
    props.closeDrawer('')
  }

  const renderAttachmentsView = () => {
    if (gridListing) {
      return (
        <Col md="12">
          {(Data.Attachments || Data.Attachements) &&
            (Data.Attachments || Data.Attachements).map((f) => {
              const withOutTild = f.FileURL
                ? f.FileURL.replace('~', '')
                : ''
              const fileURL = `${FILE_URL}${withOutTild}`
              return (
                <div className={"attachment-row"}>
                  <a href={fileURL} target="_blank" rel="noreferrer">
                    {f.OriginalFileName}
                  </a>
                </div>
              )
            })}
        </Col>
      )
    }

    if (isRfqAttachments) {
      return (
        <>
          <Col md="12">
            <div className="left-border mb-0">Feasibility</div>
            {filesFeasibility && filesFeasibility.map((f) => {
              const withOutTild = f.FileURL
                ? f.FileURL.replace('~', '')
                : ''
              const fileURL = `${FILE_URL}${withOutTild}`
              return (
                <div className={"attachment-row"}>
                  <a href={fileURL} target="_blank" rel="noreferrer">
                    {f.OriginalFileName}
                  </a>
                </div>
              )
            })}
          </Col>

          <Col md="12">
            <div className="left-border mt-3 mb-0">Capacity</div>
            {filesCapacity && filesCapacity.map((f) => {
              const withOutTild = f.FileURL
                ? f.FileURL.replace('~', '')
                : ''
              const fileURL = `${FILE_URL}${withOutTild}`
              return (
                <div className={"attachment-row"}>
                  <a href={fileURL} target="_blank" rel="noreferrer">
                    {f.OriginalFileName}
                  </a>
                </div>
              )
            })}
          </Col>

          <Col md="12">
            <div className="left-border mt-3 mb-0">Timeline</div>
            {filesTimeline && filesTimeline.map((f) => {
              const withOutTild = f.FileURL
                ? f.FileURL.replace('~', '')
                : ''
              const fileURL = `${FILE_URL}${withOutTild}`
              return (
                <div className={"attachment-row"}>
                  <a href={fileURL} target="_blank" rel="noreferrer">
                    {f.OriginalFileName}
                  </a>
                </div>
              )
            })}
          </Col>

          <Col md="12">
            <div className="left-border mt-3 mb-0">Others</div>
            {files && files.map((f) => {
              const withOutTild = f.FileURL
                ? f.FileURL.replace('~', '')
                : ''
              const fileURL = `${FILE_URL}${withOutTild}`
              return (
                <div className={"attachment-row"}>
                  <a href={fileURL} target="_blank" rel="noreferrer">
                    {f.OriginalFileName}
                  </a>
                </div>
              )
            })}
          </Col>
        </>
      )
    }

    return (
      <Col md="12">
        {(Data.attachment || Data.Attachements) &&
          (Data.attachment || Data.Attachements).map((f) => {
            const withOutTild = f.FileURL
              ? f.FileURL.replace('~', '')
              : ''
            const fileURL = `${FILE_URL}${withOutTild}`
            return (
              <div className={"attachment-row"}>
                <a href={fileURL} target="_blank" rel="noreferrer">
                  {f.OriginalFileName}
                </a>
              </div>
            )
          })}
      </Col>
    )
  }

  const renderRemarksView = () => {
    return (
      <>
        {/* Feasibility Remarks */}
        {Data?.feasibilityRemarks  && (
          <Col md="12">
            <div className="left-border mb-2">Feasibility Remarks</div>
            <div className="mt-3 mb-2">
              {Data?.feasibilityRemarks}
            </div>
          </Col>
        )}

        {/* Capacity Remarks */}
        {Data?.capacityRemarks  && (
          <Col md="12">
            <div className="left-border mt-3 mb-2">Capacity Remarks</div>
            <div className="mt-3 mb-2">
              {Data?.capacityRemarks}
            </div>
          </Col>
        )}

        {/* Timeline Remarks */}
        {Data?.timelineRemarks  && (
          <Col md="12">
            <div className="left-border mt-3 mb-2">Timeline Remarks</div>
            <div className="mt-3 mb-2">
              {Data?.timelineRemarks}
            </div>
          </Col>
        )}

        {/* Optional Remarks */}
        {Data?.remark && (
          <Col md="12">
            <div className="left-border mt-3 mb-2"> Others</div>
            <div className="mt-3 mb-2">
              {Data?.remark}
            </div>
          </Col>
        )}

        {/* Show message if no remarks */}
        {(!Data?.feasibilityRemarks) &&
          (!Data?.capacityRemarks) &&
          (!Data?.timelineRemarks) &&
          (!Data?.remark) && (
            <Col md="12">
              <div className="text-center text-muted p-4">
                No remarks available for this costing.
              </div>
            </Col>
          )}
      </>
    )
  }

  return (
    <Fragment>
      <Drawer anchor={props.anchor} open={props.isOpen}>
        <Container>
          <div className={'drawer-wrapper'}>
            <Row className="drawer-heading">
              <Col>
                <div className={'header-wrapper left'}>
                  <h3>{viewMode === 'attachments' ? 'View Attachments' : 'View Remarks'}</h3>
                </div>
                <div
                  onClick={(e) => toggleDrawer(e)}
                  className={'close-button right'}
                ></div>
              </Col>
            </Row>

            <Row className="mx-0">
              {viewMode === 'attachments' ? renderAttachmentsView() : renderRemarksView()}
            </Row>
          </div>
        </Container>
      </Drawer>
    </Fragment>
  )
}

export default React.memo(Attachament)
